import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

import { adminAppState } from '@/appState'

import { UserMenu } from './UserMenu'

type HeaderProps = {
    collapsed: boolean
    onActivate: () => void
}

export const User = observer(({ collapsed, onActivate }: HeaderProps) => {
    const { user } = adminAppState

    if (!user) {
        return null
    }

    return (
        <div
            className={classNames('shrink-0 grow-0 pb-3', {
                'px-3': !collapsed,
                'pl-1 pr-2': collapsed,
            })}
        >
            <UserMenu collapsed={collapsed} onActivate={onActivate} />
        </div>
    )
})
